import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useLayoutEffect, useState } from 'react';
import { usePreviousState } from '@atlaskit/editor-common/hooks';
import { createPreset } from '../../../create-editor/create-preset';
import { shouldRecreatePreset } from '../../../create-editor/preset-utils';
export default function useUniversalPreset(_ref) {
  var props = _ref.props;
  var previousEditorProps = usePreviousState(props);
  var _useState = useState(function () {
      return createPreset(props, previousEditorProps);
    }),
    _useState2 = _slicedToArray(_useState, 2),
    preset = _useState2[0],
    setPreset = _useState2[1];
  useLayoutEffect(function () {
    if (!previousEditorProps) {
      return;
    }
    var recreate = shouldRecreatePreset(previousEditorProps, props);
    if (!recreate) {
      return;
    }
    setPreset(createPreset(props, previousEditorProps));
  }, [props, previousEditorProps]);
  return preset;
}